import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostTradesRequestModel, PostTradesResponseModel } from "@/features/accounts/ocr/services/post-trades-model";

export class PostTradesApi {
  /**
   * OCR取込結果表示API
   */
  public PostTrades = async (
    param: PostTradesRequestModel
  ): Promise<PostTradesResponseModel> => {
    const path = `/api/ocraccounts/trades`;

    const res = await ApiClient.instance.post<PostTradesResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
